import { isMobile } from "react-device-detect";
import React from "react";
import DestinationExpertise from "../images/iconbottom/DestinationExpertise.png";
import TravelSupport from "../images/iconbottom/24_7TravelSupport.png";
import ExpertLocalPartners from "../images/iconbottom/ExpertLocalPartners.png";
import SafetyPriority from "../images/iconbottom/SafetyPriority.png";
class WhyHolxo extends React.Component {
  renderContent = () => {
    if (isMobile) {
      return (
        <div className="container text-center mt-5">
          <h2 className="text-center avenir_bolder comonfontfamilynew">
            Why Choose Holxo?
          </h2>
          <div className="testunderline mb-3"></div>
          <p className="avenir_regular mt-1 topdestingtagfont commondescripouterhedaing">
            Tried and tested over the years with 100’s of discerning travellers,
            these special breaks are the culmination of having “ears on the
            ground“ and a hunger for the special “zing“ – all researched in dept
            by our travel expert with over 30 years in experiential travel .
          </p>
          <div className="row m-0 mt-5">
            <div className="col-md-3 px-3 text-center">
              <img src={DestinationExpertise} />
              <h5 className="avenir_heavy">Destination Expertise</h5>
              <p className="avenir_regular">
                Book unforgettable experiences across India.
              </p>
            </div>
            <div className="col-md-3 px-3  text-center">
              <img src={TravelSupport} />
              <h5 className="avenir_heavy">24/7 Travel Support</h5>
              <p className="avenir_regular">
                Handle unforeseen situations to ensure your holiday runs
                smoothly.
              </p>
            </div>
            <div className="col-md-3 px-3  text-center">
              <img src={ExpertLocalPartners} />
              <h5 className="avenir_heavy">Expert Local Partners</h5>
              <p className="avenir_regular">
                Negotiate best rates for hotels and on-ground activities.
              </p>
            </div>
            <div className="col-md-3 px-3 text-center">
              <img src={SafetyPriority} />
              <h5 className="avenir_heavy">Your Safety, Our Priority</h5>
              <p className="avenir_regular">
                Experience safe and care free holidays.{" "}
              </p>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div>
        <div className="container text-center mt-5">
          <h2 className="text-center avenir_bolder comonfontfamilynew">
            Why Choose Holxo?
          </h2>
          <div className="testunderline mb-3"></div>
          <p className="avenir_regular mt-4 topdestingtagfont commondescripouterhedaing">
            Tried and tested over the years with 100’s of discerning travellers,
            these special breaks are the culmination of having “ears on the
            ground“ and a hunger for the special “zing“ – all researched in dept
            by our travel expert with over 30 years in experiential travel.
          </p>
          <div className="row m-0 mt-5">
            <div className="col-md-3 px-3 border-end text-center">
              <img src={DestinationExpertise} />
              <h5 className="avenir_heavy">Destination Expertise</h5>
              <p className="avenir_regular">
                Book unforgettable experiences across India.
              </p>
            </div>
            <div className="col-md-3 px-3  border-end text-center">
              <img src={TravelSupport} />
              <h5 className="avenir_heavy">24/7 Travel Support</h5>
              <p className="avenir_regular">
                Handle unforeseen situations to ensure your holiday runs
                smoothly.
              </p>
            </div>
            <div className="col-md-3 px-3  border-end text-center">
              <img src={ExpertLocalPartners} />
              <h5 className="avenir_heavy">Expert Local Partners</h5>
              <p className="avenir_regular">
                Negotiate best rates for hotels and on-ground activities.
              </p>
            </div>
            <div className="col-md-3 px-3 text-center">
              <img src={SafetyPriority} />
              <h5 className="avenir_heavy">Your Safety, Our Priority</h5>
              <p className="avenir_regular">
                Experience safe and care free holidays.{" "}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };
  render() {
    return this.renderContent();
  }
}
export default WhyHolxo;
